module.exports = __webpack_public_path__ + "static/media/socket-io.5dc4ade3.svg";